var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-element',{attrs:{"type":"ColumnFrame","theme":"none"}},[_vm._l((_vm.columns),function(col,index){return [_c('div',{key:index},[_vm._t("default",null,{"config":col,"index":index})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }